import { HttpClient } from "@angular/common/http";
import { Injectable, inject } from "@angular/core";

import { AjsResponse, wrapAjs } from "../ajs-response";
import { buildParams, PAGINATION_SEARCH_FIELDS } from "../http-params.util";

/**
 * ComboApiService (Angular 18).
 *
 * Replaces apps/b2b-ui/common/services/api/comboApi/comboApi.service.js.
 *
 * Single namespace `templates` exposed under `apiService.combo.templates.*`.
 * Legacy mutations hit `/v1/api/combo/event/templates`; `list()` uses v2.
 */
const COMBO_TEMPLATES_BASE_V1 = "/v1/api/combo/event/templates";
const COMBO_TEMPLATES_BASE_V2 = "/v2/api/combo/event/templates";

const COMBO_LIST_FIELDS = [...PAGINATION_SEARCH_FIELDS, "summary"] as const;

@Injectable({ providedIn: "root" })
export class ComboApiService {
  private readonly http = inject(HttpClient);

  readonly templates = {
    create: (props: unknown): Promise<AjsResponse<unknown>> =>
      wrapAjs(this.http.post<unknown>(COMBO_TEMPLATES_BASE_V1, props)),

    update: (props: unknown): Promise<AjsResponse<unknown>> =>
      wrapAjs(this.http.put<unknown>(COMBO_TEMPLATES_BASE_V1, props)),

    remove: (id: number | string): Promise<AjsResponse<unknown>> =>
      wrapAjs(this.http.delete<unknown>(`${COMBO_TEMPLATES_BASE_V1}/${id}`)),

    list: (props?: Record<string, unknown>): Promise<AjsResponse<unknown>> =>
      wrapAjs(
        this.http.get<unknown>(COMBO_TEMPLATES_BASE_V2, {
          params: buildParams(props, COMBO_LIST_FIELDS),
        }),
      ),

    get: (id: number | string): Promise<AjsResponse<unknown>> =>
      wrapAjs(this.http.get<unknown>(`${COMBO_TEMPLATES_BASE_V1}/${id}`)),
  };
}
